import React from "react";
import Layout from "../Layout";
import Link from "next/link";

export const SubscriptionNeeded = ({ subscription, message }) => {
    return (
        (<Layout title="Du brauchst mehr Power?">
            <div className="container">
                <div className="d-flex justify-content-around">
                    <img
                        className="rounded shadow"
                        src="https://unsplash.com/photos/K4mSJ7kc0As/download?force=true"
                        style={{ height: "50vh" }}
                    />
                    <div className="p-3 text-center">
                        <h1>{message}</h1>
                        <div className="d-flex justify-content-around my-3">
                            <Link href="/trainingsplanerstellung" className="btn btn-light">
                                Weitere Informationen
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>)
    );
};
